<div class="main-div">
  <mat-toolbar color="#000000">
    <h1 class="cdlt-heading">Clinical Documentation Lookup Tool (CDLT)</h1>
    <span class="space"></span>

    <button mat-button class="header-text" data-analytics="cdltHomeTopNav" (click)="onCDLTHomeClick()">CDLT
      Home</button>
    <button mat-button class="header-text" data-analytics="demoTopNav" (click)="onDemoClick()">Demo</button>
    <button mat-button class="header-text" data-analytics="faqTopNav" (click)="onFAQClick()">FAQ</button>
  </mat-toolbar>
</div>